// extracted by mini-css-extract-plugin
export default {"overlay":"LinkOverlay-module--overlay--97d67","container":"LinkOverlay-module--container--c2aa3"};